export const MAP = {
  H01D: "HP-Headline-01-d",
  H02D: "HP-Headline-02-d",
  H03D: "HP-Headline-03-d",
  H04D: "HP-Headline-04-d",
  H05D: "HP-Headline-05-d",
  S01D: "HP-Subtitle-01-d",
  S02D: "HP-Subtitle-02-d",
  S03D: "HP-Subtitle-03-d",
  B01D: "HP-Body-01-d",
  B02D: "HP-Body-02-d",
  B03D: "HP-Body-03-d",
  B04D: "HP-Body-04-d",
  BUTTON01D: "HP-Button-01-d",
  BUTTON02D: "HP-Button-02-d",
  CAPTION01D: "HP-Caption-01-d",
  CAPTION02D: "HP-Caption-02-d",
  OVERLINE01D: "HP-Overline-01-d",
  OVERLINE02D: "HP-Overline-02-d",
};

export const FAMILIES = {
  MONTSERRAT: [MAP.H01D, MAP.H02D, MAP.H03D, MAP.H04D, MAP.H05D],
};
